import React from 'react';

interface ScoreMappingConfig {
  min: number;
  max: number;
  label: string;
  recommendation: string;
}

interface ScoreMappingProps {
  scoreMapping: Record<string, ScoreMappingConfig>;
  onChange: React.Dispatch<React.SetStateAction<Record<string, ScoreMappingConfig>>>;
}

export default function ScoreMapping({ scoreMapping, onChange }: ScoreMappingProps) {
  const handleChange = (grade: string, field: 'min' | 'max', value: string) => {
    const newMapping = { ...scoreMapping };
    newMapping[grade] = { ...newMapping[grade], [field]: parseInt(value) || 0 };
    onChange(newMapping);
  };

  const getBadgeColor = (recommendation: string) => {
    switch (recommendation) {
      case 'approve':
        return 'bg-green-100 text-green-700';
      case 'review':
        return 'bg-amber-100 text-amber-700';
      default:
        return 'bg-red-100 text-red-700';
    }
  };

  const getRecommendationLabel = (recommendation: string) => {
    switch (recommendation) {
      case 'approve':
        return 'Setuju';
      case 'review':
        return 'Review';
      default:
        return 'Tolak';
    }
  };

  return (
    <div className="bg-white border rounded-lg">
      <div className="p-4 border-b">
        <h3 className="font-semibold">Mapping Skor</h3>
      </div>
      <div className="p-4 space-y-3">
        {Object.entries(scoreMapping).map(([grade, config]) => (
          <div key={grade} className="p-3 border rounded-lg space-y-2">
            <div className="flex items-center justify-between">
              <span className="font-bold text-lg">{grade}</span>
              <span
                className={`px-2 py-1 rounded text-xs font-medium ${getBadgeColor(config.recommendation)}`}
              >
                {getRecommendationLabel(config.recommendation)}
              </span>
            </div>
            <p className="text-sm font-medium">{config.label}</p>
            <div className="grid grid-cols-2 gap-2 mt-2">
              <div>
                <label className="block text-xs text-gray-500 mb-1">Min</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  value={config.min}
                  onChange={e => handleChange(grade, 'min', e.target.value)}
                  className="w-full px-2 py-1 border rounded text-sm focus:outline-none focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1">Max</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  value={config.max}
                  onChange={e => handleChange(grade, 'max', e.target.value)}
                  className="w-full px-2 py-1 border rounded text-sm focus:outline-none focus:border-blue-500"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
